import React, { useEffect, useState, useRef, useContext } from "react";
import Logo from "../../images/MY-Anlook.png";
import { Link } from "react-router-dom";
import useHeatMap from "../../services/LandingPage/useHeatMap";
import { GlobalContext } from "../../Context/GlobalContext";
import { ChevronDown } from "lucide-react";

const Navbar = () => {
  const { login } = useContext(GlobalContext);

const [desktopServicesOpen, setDesktopServicesOpen] = useState(false);
const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuWrapperRef = useRef(null);

  const [sessionID, setSessionId] = useState("");
  const [campaignIdHook, setCampaignIdHook] = useState("");
  const menuRef = useRef(null);
  const { trackClick } = useHeatMap();

  // ================= Scroll Effect =================
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // ================= Outside Click =================
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!menuOpen) return;
      if (
        menuWrapperRef.current &&
        !menuWrapperRef.current.contains(e.target) &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  // ================= Campaign ID =================
  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    let campaignid = params.get("campaignid");

    if (!campaignid) {
      params = new URLSearchParams(window.location.hash.substring(1));
      campaignid = params.get("campaignid");
    }

    if (campaignid) {
      sessionStorage.setItem("campaignId", campaignid);
      setCampaignIdHook(campaignid);
    }
  }, []);

  // ================= Body Scroll Lock =================
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuWrapperRef.current &&
        !menuWrapperRef.current.contains(e.target)
      ) {
        setDesktopServicesOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // ================= Heatmap Click =================
  const handleTrackClick = async (buttonName) => {
    await trackClick({
      campaignid: campaignIdHook,
      sessionid: sessionID,
      element: "Button",
      button_name: buttonName,
      pageurl: window.location.href,
      pagename: "Navbar",
      product: "Anlook",
    });
  };

  return (
    <>
      <div
        className={`fixed top-0 left-0 right-0 h-[75px] z-[9999] transition-all duration-300 ${
          scrolled ? "bg-white shadow-md" : "bg-white"
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-20">
          <div
            className="h-[75px] flex items-center justify-between"
            ref={menuWrapperRef}
          >
            {/* LOGO */}
            <Link to="/">
              <img src={Logo} alt="Logo" className="w-[160px]" />
            </Link>

            {/* DESKTOP LINKS */}
            <div className="hidden lg:flex gap-8">
              <a href="/" className="nav-link">
                Home
              </a>
              <a href="/about-us" className="nav-link">
                About
              </a>
              {/* <Link to="/pricing-page" className="nav-link">
                Pricing
              </Link> */}
              <a href="/blogs" className="nav-link">
                Blogs
              </a>
              <a href="/contact-us" className="nav-link">
                Contact us
              </a>
              <div className="relative">
                <button
                  onClick={() => setDesktopServicesOpen(!desktopServicesOpen)}
                  className="nav-link flex items-center gap-1"
                >
                  Services
                  <ChevronDown
                    size={16}
                    className={`transition-transform duration-200 ${
                      desktopServicesOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {desktopServicesOpen && (
                  <div className="absolute top-full left-0 pt-2">
                    <div className="w-56 bg-white rounded-xl shadow-xl border border-gray-100 py-2">
                      <Link
                        to="/services/whatsapp"
                        onClick={() => setDesktopServicesOpen(false)}
                        className="block px-4 py-2 hover:bg-green-50 hover:text-green-600"
                      >
                        WhatsApp Services
                      </Link>

                      <Link
                        to="/services/pos"
                        onClick={() => setDesktopServicesOpen(false)}
                        className="block px-4 py-2 hover:bg-green-50 hover:text-green-600"
                      >
                        POS Services
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* DESKTOP BUTTONS */}
            <div className="hidden lg:flex gap-2">
              <Link
                to="/get-started"
                onClick={() => handleTrackClick("Get Started")}
                className="bg-[#01C37D] text-white px-[22px] py-2 rounded-lg font-semibold hover:opacity-90 transition"
              >
                Start Free Trial
              </Link>

              <button
                onClick={() => {
                  handleTrackClick("Login");
                  login();
                }}
                className="bg-green-600 text-white px-4 py-2 rounded-md hover:opacity-90 transition"
              >
                Login
              </button>
            </div>

            {/* MOBILE MENU ICON */}
            <div
              className="block lg:hidden text-[26px] cursor-pointer"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              ☰
            </div>
          </div>
        </div>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div
          ref={menuRef}
          className="fixed top-[75px] left-0 w-full bg-white p-5 text-center shadow-lg z-[2000]"
        >
          <a href="/" onClick={() => setMenuOpen(false)} className="block py-3">
            Home
          </a>
          <a
            href="/about-us"
            onClick={() => setMenuOpen(false)}
            className="block py-3"
          >
            About
          </a>
          {/* <Link
            to="/pricing-page"
            onClick={() => setMenuOpen(false)}
            className="block py-3"
          >
            Pricing
          </Link> */}
          <a
            href="/blogs"
            onClick={() => setMenuOpen(false)}
            className="block py-3"
          >
            Blogs
          </a>
          <a
            href="/contact-us"
            onClick={() => setMenuOpen(false)}
            className="block py-3"
          >
            Contact us
          </a>

          <div className="text-center">
            <button
              onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
              className="w-full flex justify-center items-center gap-2 py-3"
            >
              <span>Services</span>
              <ChevronDown
                size={16}
                className={`transition-transform duration-200 ${
                  mobileServicesOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {mobileServicesOpen && (
              <div className="mt-2 flex flex-col items-center">
                <Link
                  to="/services/whatsapp"
                  onClick={() => {
                    setMenuOpen(false);
                    setMobileServicesOpen(false);
                  }}
                  className="block py-2 text-center w-full"
                >
                  WhatsApp Services
                </Link>

                <Link
                  to="/services/pos"
                  onClick={() => {
                    setMenuOpen(false);
                    setMobileServicesOpen(false);
                  }}
                  className="block py-2 text-center w-full"
                >
                  POS Services
                </Link>
              </div>
            )}
          </div>

          <div className="flex flex-col gap-4 mt-5">
            <button
              onClick={() => {
                handleTrackClick("Login");
                setMenuOpen(false);
                login();
              }}
              className="bg-green-600 text-white px-4 py-3 rounded-md"
            >
              Login
            </button>

            <Link
              to="/get-started"
              onClick={() => {
                handleTrackClick("Get Started");
                setMenuOpen(false);
              }}
              className="block bg-[#01C37D] text-white py-3 rounded-lg font-semibold"
            >
              Start Free Trial
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
